import { PcbNodeTypes, } from "@buildwithflux/models";
import { capitalize } from "lodash";
import { vec2 } from "../common";
import { updateNodePositionRules } from "../pcb/interactions/updateNodePositionRules";
export function buildDesignatorToUidMap(pcbNodes) {
    const designators = Object.values(pcbNodes)
        .filter((n) => n.type === PcbNodeTypes.element)
        .map((n) => n.name);
    const designatorsToUids = new Map();
    Object.values(pcbNodes)
        .filter((n) => n.type === PcbNodeTypes.element)
        // eslint-disable-next-line @buildwithflux/no-array-foreach
        .forEach((n) => {
        if (!designatorsToUids.has(n.name)) {
            designatorsToUids.set(n.name, n.uid);
        }
    });
    if (new Set(designators).size !== designators.length) {
        throw new Error("duplicate designators found in PCB nodes");
    }
    return designatorsToUids;
}
export function applyAutoPlacementResults(result, pcbNodes, designatorsToUids) {
    const updatedNodes = {};
    // eslint-disable-next-line @buildwithflux/no-array-foreach
    result.componentPlacements.forEach((placement) => {
        const node = pcbNodes[designatorsToUids.get(placement.componentDesignator) ?? ""];
        if (!node)
            return;
        updatedNodes[node.uid] = {
            nodeUid: node.uid,
            updatedPcbLayoutRules: {
                ...updateNodePositionRules(node, vec2.scale(placement.position, 1 / 1000)), // mm to m
                rotationZ: {
                    uid: "rotationZ",
                    key: "rotationZ",
                    value: `${placement.rotation}deg`,
                    disabled: false,
                },
                layer: { uid: "layer", key: "layer", value: capitalize(placement.layer), disabled: false },
            },
        };
    });
    return updatedNodes;
}
//# sourceMappingURL=index.js.map